import React, { useEffect, useState } from 'react';
import { track } from '../helpers/analytics';
import { getPlatform } from '../helpers/platform';
import { APP_STORE_URL, PLAY_STORE_URL } from './AppBanner';
import { t } from '../i18n';
import './MobileLanding.scss';

/**
 * MobileLanding — static store-funnel page shown to phone visitors instead of
 * the live map (no WebGL map, no Firestore subscriptions on mobile browsers).
 * Shows a pre-rendered shot of a painted neighborhood and a dialog pointing
 * to the visitor's app store. Deliberately no path to the live map — on a
 * phone the answer is always the app.
 */
const MobileLanding = () => {
    const platform = getPlatform();
    // The landing only mounts for ios/android, but keep a sane default.
    const storeUrl = platform === 'android' ? PLAY_STORE_URL : APP_STORE_URL;
    const storeLabel = platform === 'android' ? 'Google Play' : 'App Store';

    const [entered, setEntered] = useState(false);
    useEffect(() => {
        track('mobile_landing_shown', { platform });
        // Let the dialog slap in on the frame after mount
        const raf = requestAnimationFrame(() => setEntered(true));
        return () => cancelAnimationFrame(raf);
    }, [platform]);

    const handleStoreClick = () => {
        track('mobile_landing_store_clicked', { store: platform === 'android' ? 'play_store' : 'app_store', platform });
    };

    return (
        <div className="mobile-landing" data-testid="mobile-landing">
            <img
                className="mobile-landing__map"
                src={`${process.env.PUBLIC_URL}/map/landing-map.jpg`}
                alt={t('web.landing.mapAlt')}
            />
            <div className="mobile-landing__scrim" />

            <div className={'mobile-landing__dialog' + (entered ? ' mobile-landing__dialog--in' : '')}>
                <img
                    className="mobile-landing__icon"
                    src={`${process.env.PUBLIC_URL}/icon/android-chrome-192x192.png`}
                    alt=""
                    aria-hidden="true"
                />
                <h1 className="mobile-landing__title">Paint the World</h1>
                <p className="mobile-landing__subtitle">{t('web.landing.subtitle')}</p>
                <a
                    className="mobile-landing__store-btn"
                    href={storeUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={handleStoreClick}
                    aria-label={platform === 'android' ? t('web.banner.getOnGooglePlay') : t('web.banner.downloadAppStore')}
                >
                    {t('web.landing.getItOn', { store: storeLabel })}
                </a>
            </div>
        </div>
    );
};

export default MobileLanding;
